import { Nav } from "../ui/Nav";
import { Hero } from "../blocks/Hero";
import { Problem } from "../blocks/Problem";
import { Plan } from "../blocks/Plan";
import { Inside } from "../blocks/Inside";
import { Trust } from "../blocks/Trust";
import { Faq } from "../blocks/Faq";
import { CtaValley } from "../blocks/CtaValley";
import { Footer } from "../blocks/Footer";
import { useBlockVisibility } from "../hooks/useBlockVisibility";

const Section = ({
  name,
  index,
  children,
}: {
  name: string;
  index: number;
  children: React.ReactNode;
}) => {
  const ref = useBlockVisibility(name, index);
  return (
    <div ref={ref as React.RefObject<HTMLDivElement>}>{children}</div>
  );
};

export function Landing() {
  return (
    <div className="min-h-screen bg-[var(--color-cream)]">
      <Nav />
      <main>
        <Section name="hero" index={0}><Hero /></Section>
        <Section name="problem" index={1}><Problem /></Section>
        <Section name="plan" index={2}><Plan /></Section>
        <Section name="inside" index={3}><Inside /></Section>
        <Section name="trust" index={4}><Trust /></Section>
        <Section name="faq" index={5}><Faq /></Section>
        <Section name="cta_valley" index={6}><CtaValley /></Section>
      </main>
      <Footer />
    </div>
  );
}
